// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2640":"fcc857a688ee2df6","4385":"4be6478f6545911b","6078":"c9dbe9e6716119c4"}[chunkId] + ".css";
};